import React from 'react';
import { PostData } from '../data/forumData';
const avatarColors = {
  blue: 'bg-[#d0e8fa] text-[#185FA5]',
  gray: 'bg-[#e8e6df] text-[#5F5E5A]',
  green: 'bg-[#dff0cc] text-[#3B6D11]',
  amber: 'bg-[#faebd0] text-[#854F0B]',
  red: 'bg-[#fce8e8] text-[#A32D2D]',
  purple: 'bg-[#eeedfe] text-[#534AB7]',
  teal: 'bg-[#d0f0ec] text-[#0e6b60]',
  brown: 'bg-[#ede0d0] text-[#6b3d0e]'
};
export const ForumPost = ({
  post
}: {
  post: PostData;
}) => {
  return <div className="flex flex-col md:flex-row bg-white border border-[#ddd] border-t-0 first:border-t first:rounded-t-[6px] last:rounded-b-[6px]" data-id="element-121">
      {/* Sidebar - horizontal on mobile, vertical column on desktop */}
      <div className="md:w-[145px] md:min-w-[145px] p-[0.75rem] md:p-[1rem_0.75rem] border-b md:border-b-0 md:border-r border-[#eee] bg-[#fafaf8] flex flex-row md:flex-col items-center gap-[0.5rem] md:gap-[0.3rem]" data-id="element-122">
        <div className={`w-[36px] h-[36px] md:w-[50px] md:h-[50px] rounded-[5px] flex items-center justify-center text-[16px] md:text-[20px] font-extrabold shrink-0 ${avatarColors[post.avatar.color]}`} data-id="element-123">
          {post.avatar.letter}
        </div>
        <div className="flex flex-row md:flex-col items-center md:items-center gap-[0.35rem] md:gap-[0.15rem] min-w-0" data-id="element-124">
          <div className="text-[12px] font-bold text-[#185FA5] text-center break-all" data-id="element-125">
            {post.username}
          </div>
          {post.isStammgast ? <div className="inline-flex items-center gap-[3px] text-[10px] font-bold text-[#b8860b]" data-id="element-126">
              ⭐ Stammgast
            </div> : <div className="text-[10px] text-[#999] text-center" data-id="element-127">
              {post.role}
            </div>}
        </div>
        <div className="hidden md:block text-[10px] text-[#999] text-center leading-[1.6] mt-[0.25rem]" data-id="element-128">
          Dabei seit:
          <br data-id="element-129" />
          {post.stats.joined}
          <br data-id="element-130" />
          Beiträge: {post.stats.posts}
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 p-[0.75rem] md:p-[0.9rem_1.1rem] min-w-0" data-id="element-131">
        <div className="flex justify-between items-start mb-[0.7rem] border-b border-[#f0ede8] pb-[0.55rem]" data-id="element-132">
          {post.title ? <div className="md:text-[15px] font-bold text-[#1a1a1a] min-w-0 text-[20px]" data-id="element-133">
              {post.title}
            </div> : <div className="text-[11px] text-[#999]" data-id="element-134">{post.datetime}</div>}
          <div className="flex flex-col items-end gap-[2px] whitespace-nowrap ml-[0.5rem] md:ml-[1rem]" data-id="element-135">
            {post.title && <div className="text-[11px] text-[#999]" data-id="element-136">{post.datetime}</div>}
            <div className="text-[11px] text-[#aaa] font-medium" data-id="element-137">
              #{post.id}
            </div>
          </div>
        </div>
        <div className="post-text text-[13px] md:text-[13.5px] leading-[1.85] text-[#1a1a1a] break-words overflow-hidden" data-id="element-138">
          {post.content}
        </div>
      </div>
    </div>;
};